<template>
  <span
    class="inline-flex items-center px-1 py-1 rounded-md text-xs font-medium leading-5"
    :class="color"
  >
    {{ statusText }}
  </span>
</template>

<script>
export default {
    data() {
        return {
            colors: {
                "0": ["bg-gray-300", "text-white"],
                "1": ["bg-gray-500", "text-white"],
                "2": ["bg-orange-300", "text-white"],
                "3": ["bg-orange-400", "text-white"],
                "4": ["bg-green-400", "text-white"],
            }
        };
    },
    props: {
        status: {
            type: Number,
            default: null
        },
        statusText: {
            type: String,
            default: null
        }
    },
    computed: {
        color() {
            return this.colors[this.status];
        }
    }
};
</script>

<style></style>
